import { Button, dialog } from "nq-component";
import BaseListPresenter from "../../../base/BaseListPresenter";
import InputFactory from "../../../components/InputFactory";
import { renderToStaticMarkup } from "react-dom/server";
import IpcrListPrint from "../print-component/IpcrListPrint";

class IPCRPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    this.limit = 10;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = [
      "employee.position",
      "supervisor.position",
      "assignedEmployee",
      "assignedEmployee.position",
    ];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  // handlePrintData(object) {
  //   let headName = "";
  //   let headPosition = "";
  //   dialog.fire({
  //     html: (
  //       <div className="ps-3 pe-3 pt-1 pb-2">
  //         <form
  //           onSubmit={(e) => {
  //             e.preventDefault();
  //             this.handlePrint(object, headName, headPosition);
  //           }}
  //         >
  //           <div className="row">
  //             <h4>Confirmation</h4>
  //             <hr />
  //             <div className="pt-1">
  //               <label className="form-label fs-sm">Head Of Office</label>
  //               <InputFactory
  //                 required
  //                 type="String"
  //                 onChange={(val) => (headName = val)}
  //               />
  //             </div>
  //             <div className="pb-2">
  //               <label className="form-label fs-sm">Position</label>
  //               <InputFactory
  //                 required
  //                 type="String"
  //                 onChange={(val) => (headPosition = val.toUpperCase())}
  //               />
  //             </div>
  //             <hr />
  //           </div>
  //           <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
  //             <Button
  //               type="button"
  //               className="btn btn-light fs-sm"
  //               onClick={() => dialog.close()}
  //             >
  //               Cancel
  //             </Button>
  //             <Button className="btn btn-primary" type="submit">
  //               Confirm
  //             </Button>
  //           </div>
  //         </form>
  //       </div>
  //     ),
  //     footer: false,
  //   });
  // }

  handlePrint(data) {
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    const printContentElement = IpcrListPrint(data);
    const printContentHTML = renderToStaticMarkup(printContentElement);

    iframeDoc.open();
    iframeDoc.write(
      `<html><head><title>Print DTR</title><style>
    @page {
      margin: 1mm;
    }
    body {
      font-family: Arial, sans-serif;
      margin: 0;
      padding: 0;
      font-size: 14px;
    }
    .print-content-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .print-content {
      width: 100%;
      max-width: 100%;
      margin: 0;
      padding: 10px;
    }
    @media print {
      th {
        font-weight: normal; 
      }
    }
  </style></head><body>`
    );

    iframeDoc.write(printContentHTML);

    // Adding the script for the onload callback function
    iframeDoc.write(`<script>
      window.print();
      window.close();
      </script>`);

    iframeDoc.write("</body></html>");
    iframeDoc.close();
  }
}
export default IPCRPresenter;
